export default __webpack_public_path__ + "images/68fa64fb014dd162e206f6647f228b5f.svg";